module.exports = __webpack_public_path__ + "media/logo/Group 554-8ca15fa7.jpg";